<template>
  <Form :model="formValidate" :rules="ruleValidate" :label-width="80">
    <FormItem prop="name">
      <Input v-model="formValidate.name" placeholder="Enter your name" />
    </FormItem>
  </Form>
</template>
<script>
export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Please enter your password"));
      } else {
        callback();
      }
    };
    return {
      formValidate: {
        name: ""
      },
      ruleValidate: {
        name: [{ validator: validatePass, trigger: "blur" }]
      }
    };
  },
  methods: {}
};
</script>
